import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import HttpService from '../views/services/components/httpservices';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react'
// sidebar nav config
import { navigation, retailer, financer, distributor, salesOfficerMenu } from './_nav';
import { freeSet } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

const header = {
  'Content-Type': 'application/json',
  'authorization': localStorage.getItem("token")
};

const TheSidebar = () => {
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow);
  // const [hasCustomSetting,setHasCustomSetting] = useState(localStorage.getItem('has_custom_setting'));
  const [settingDetail, setSettingDetail] = useState();
  const getSettingDetails = async () => {
    await HttpService.get("setting_details", header).then((response) => {
      setSettingDetail(response.data.data);
    }).catch((error) => {
      console.log(error.msg);
    });
  }

  useEffect(() => {
    getSettingDetails();
  }, [])
  const styleCenter = {
    justifyContent: "flex-centers",
    "fontWeight": "600"
  }

  return (
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
    >
      <CSidebarBrand className="d-md-down-none d-flex justify-content-around" style={styleCenter} to="/">
        <img src={settingDetail?.app_logo_url} style={{ "height": "50px" }} alt={settingDetail?.app_name || ""} />
        {settingDetail?.app_name}
      </CSidebarBrand>
      <CSidebarNav>
        {(localStorage.getItem("role") === "admin") ?
          <CCreateElement
            items={navigation}
            components={{
              CSidebarNavDivider,
              CSidebarNavDropdown,
              CSidebarNavItem,
              CSidebarNavTitle
            }}
          />
          : (localStorage.getItem("role") === "retailer") ?
            <CCreateElement
              items={retailer}
              components={{
                CSidebarNavDivider,
                CSidebarNavDropdown,
                CSidebarNavItem,
                CSidebarNavTitle
              }}
            />
            : (localStorage.getItem("role") === "financer") ?
              <CCreateElement
                items={financer}
                components={{
                  CSidebarNavDivider,
                  CSidebarNavDropdown,
                  CSidebarNavItem,
                  CSidebarNavTitle
                }}
              />
              : (localStorage.getItem("role") === "distributor") ?
                <CCreateElement
                  items={distributor}
                  components={{
                    CSidebarNavDivider,
                    CSidebarNavDropdown,
                    CSidebarNavItem,
                    CSidebarNavTitle
                  }}
                />
                : (localStorage.getItem("role") === "sales-officer") ? 
                  <CCreateElement
                      items={salesOfficerMenu}
                      components={{
                        CSidebarNavDivider,
                        CSidebarNavDropdown,
                        CSidebarNavItem,
                        CSidebarNavTitle
                      }}
                    /> 
                : 
                    null
                }
              
              {
                (localStorage.getItem("role") === "retailer") && <>
                  <li className="c-sidebar-nav-item">
                    <a className="c-sidebar-nav-link" target='_blank' href="https://vimeo.com/710657144"> <CIcon content={freeSet.cilLink} /> <span className='ml-4'>Tutorial</span></a>
                  </li>
                </>
              }

      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
